
  import { MODAL_LIST_DATA } from '@/constants/modals';

  export default {
    props: {
      video: { type: Object, required: true }
    },
    methods: {
      show () {
        this.$store.commit('modal/PUSH_MODAL', { id: MODAL_LIST_DATA.VIDEO, settings: this.video });
      }
    }
  };
 